import {ActionTree} from "vuex";
import {TradeContractFormat, TradeContractFormatState} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";
import Qs from "qs";

const actions: ActionTree<TradeContractFormatState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    const paramsHash = {
      params: params,
      paramsSerializer: function (params: object) {
        return Qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    return rootGetters['hcs/client'].get('/trade_contract_formats', paramsHash)
      .then((response: AxiosResponse) => {
        const calendars: TradeContractFormat[] = response.data;
        commit('setTradeContractFormats', calendars)
        return calendars
      })
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/trade_contract_formats', params)
      .then((response: AxiosResponse) => {
        const calendar: TradeContractFormat = response.data;
        commit('addTradeContractFormat', calendar)
        return calendar
      })
  },
  update({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].patch(`/trade_contract_formats/${params.id}`, params)
      .then((response: AxiosResponse) => {
        const calendar: TradeContractFormat = response.data;
        commit(('updateTradeContractFormat'), calendar)
        return calendar
      })
  },
  delete({ rootGetters, commit }, id) {
    return rootGetters['hcs/client'].delete(`/trade_contract_formats/${id}`)
      .then((response: AxiosResponse) => {
        commit(('deleteTradeContractFormat'), id)
      })
  }
}

export default actions;
